import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {WebshopRestService} from '../../services/api/webshop-rest.service';
import * as fromUberActions from '../actions/uber.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {ProductsResponse} from '../../models/shop/products-response.model';
import {of} from 'rxjs/internal/observable/of';

@Injectable()
export class UberEffects {
    private actions$ = inject(Actions);
    private productRestService = inject(WebshopRestService);

    loadUberByVendorId$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromUberActions.UberLoadAction>(
                fromUberActions.UberActionTypes.UBER_LOAD
            ),
            map(action => action.payload),
            switchMap(rq =>
                this.productRestService.loadUberByVendorId(rq).pipe(
                    switchMap(data => {
                        const resp = new ProductsResponse({ ...data.returnObject });
                        return [new fromUberActions.UberLoadCompleteAction(resp)];
                    }),
                    catchError(error => of(new fromUberActions.UberLoadFailAction(error)))
                )
            )
        )
    );

    loadUberVendors$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromUberActions.UberLoadVendorsAction>(
                fromUberActions.UberActionTypes.UBER_LOAD_VENDORS
            ),
            map(action => action),
            switchMap(() =>
                this.productRestService.loadUberVendors().pipe(
                    map(data => new fromUberActions.UberLoadVendorsCompleteAction(data.returnObject)),
                    catchError(error => of(new fromUberActions.UberLoadVendorsFailAction(error)))
                )
            )
        )
    );
}